import Header from '../../components/feature/Header';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Contact from './components/Contact';
import Footer from './components/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';
import { SEO, getStructuredData, getFAQStructuredData } from '../../utils/seo';

export default function Home() {
  const structuredData = getStructuredData();
  const faqStructuredData = getFAQStructuredData();

  return (
    <>
      <SEO 
        title="PRIMECONDOMINIALSOLUCOES - Serviços Especializados para Prédios e Condomínios em Canoas RS"
        description="PRIMECONDOMINIALSOLUCOES oferece serviços completos para prédios e condomínios em Canoas RS: manutenção predial, jardinagem, segurança 24h, limpeza especializada, administração predial e reformas. 15+ anos de experiência, 500+ condomínios atendidos."
        keywords="manutenção predial, administração condomínio, segurança predial, jardinagem condomínio, limpeza especializada"
        structuredData={structuredData}
      />
      <script type="application/ld+json">
        {JSON.stringify(faqStructuredData)}
      </script>
      
      <main>
        <Header />
        <Hero />
        <About />
        <Services />
        <Contact />
        <Footer />
        <WhatsAppButton />
      </main>
    </>
  );
}